<template>
    <CqNotifications :notifications="notifications" />
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import {CqNotifications, UserNotification} from '@cquential/ui';

    @Component({
        components: {
            CqNotifications,
        },
    })
    export default class Notify extends Vue {
        private static readonly NOTIFICATIONS_CLEANUP_COUNT: number = 1000;
        private static readonly NOTIFICATIONS_KEEP_COUNT: number = 100;
        private static instance: Notify | null = null;

        public notifications: UserNotification[] = [];

        public mounted(): void {
            Notify.instance = this;
        }

        public beforeUnmount(): void {
            Notify.instance = null;
        }

        public notify(message: UserNotification): void {
            this.notifications.push(message);

            // every time there's more than a 1000, remove the first 900
            // this is a "stupid" way to prevent a memory leak
            // we'll just assume you won't get those last 100 notifications so quickly that we're removing visible notifications
            if (this.notifications.length > Notify.NOTIFICATIONS_CLEANUP_COUNT) {
                this.notifications.splice(0, Notify.NOTIFICATIONS_CLEANUP_COUNT - Notify.NOTIFICATIONS_KEEP_COUNT);
            }
        }

        public static createNotification(message: UserNotification): void {
            this.instance!.notify(message);
        }
    }
</script>
